import client from './client';

export const getProviderWeeklyHoursApi = providerId => client().get('/provider-weekly-hours', { params: { providerId } });

export const createProviderWeeklyHoursApi = data => client().post('/provider-weekly-hours', data);

export const removeProviderWeeklyHourApi = id => client().delete(`/provider-weekly-hours/${id}`);

export const updateProviderWeeklyHourApi = data => client().put(`/provider-weekly-hours/${data.id}`, data);
